export default "__VITE_ASSET__2409b319__"